import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import { Accordion } from '@udemy-v2/react-reveal-components';
import React from 'react';
import { useDeviceType } from '@udemy-v2/hooks';
import { useI18n } from '@udemy-v2/i18n';
import './course-requirements.module.scss';
interface RequirementsProps {
  prerequisites: string[];
  isCollapsible?: boolean;
  className?: string;
  titleTypography?: 'ud-heading-lg' | 'ud-heading-xl';
  onAccordionToggle?: () => void;
}
export function Requirements(t0) {
  const $ = _c(27);
  const {
    prerequisites: t1,
    isCollapsible: t2,
    className: t3,
    titleTypography: t4,
    onAccordionToggle
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const prerequisites = t5;
  const isCollapsible = t2 === undefined ? false : t2;
  const className = t3 === undefined ? "component-margin" : t3;
  const titleTypography = t4 === undefined ? "ud-heading-xl" : t4;
  let t6;
  if ($[2] !== titleTypography) {
    t6 = () => {
      switch (titleTypography) {
        case "ud-heading-lg":
          {
            return "large";
          }
        case "ud-heading-xl":
        default:
          {
            return "xlarge";
          }
      }
    };
    $[2] = titleTypography;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const getAccordionSize = t6;
  const {
    gettext
  } = useI18n();
  const deviceType = useDeviceType();
  if (!prerequisites.length) {
    return null;
  }
  let t7;
  if ($[4] !== gettext) {
    t7 = gettext("Requirements");
    $[4] = gettext;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const title = t7;
  let t8;
  if ($[6] !== prerequisites) {
    t8 = prerequisites.map(_temp);
    $[6] = prerequisites;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const requirements = t8;
  const shouldCollapse = deviceType === "mobile" || isCollapsible;
  if (!shouldCollapse) {
    const t9 = `title ${titleTypography}`;
    let t10;
    if ($[8] !== t9 || $[9] !== title) {
      t10 = <h2 data-purpose="requirements-title" className={t9}>{title}</h2>;
      $[8] = t9;
      $[9] = title;
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    let t11;
    if ($[11] !== requirements) {
      t11 = <BlockList size="small" padding="tight">{requirements}</BlockList>;
      $[11] = requirements;
      $[12] = t11;
    } else {
      t11 = $[12];
    }
    let t12;
    if ($[13] !== className || $[14] !== t10 || $[15] !== t11) {
      t12 = <div className={className}>{t10}{t11}</div>;
      $[13] = className;
      $[14] = t10;
      $[15] = t11;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    return t12;
  }
  const t9 = getAccordionSize();
  let t10;
  if ($[17] !== requirements) {
    t10 = <BlockList size="small" padding="tight">{requirements}</BlockList>;
    $[17] = requirements;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onAccordionToggle || $[20] !== t10 || $[21] !== title) {
    t11 = <Accordion.Panel title={title} onToggle={onAccordionToggle}>{t10}</Accordion.Panel>;
    $[19] = onAccordionToggle;
    $[20] = t10;
    $[21] = title;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== className || $[24] !== t11 || $[25] !== t9) {
    t12 = <Accordion size={t9} className={className}>{t11}</Accordion>;
    $[23] = className;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp(item, index) {
  return <BlockList.Item key={`requirement-${item}-${index}`} icon={<Icon glyph="bullet" label="" />}>{item}</BlockList.Item>;
}